import { ApiError, ApiRedirect } from 'helpers/error';
import axios from 'axios';
import { CONTENT_API_URL, ECOMMERCE_API_URL } from './_constants';
// import { COMMERCEMEDIA_API_URL } from './_constants';
// import { CONTENT_API_URL } from '../cms/constants';

export interface RequestInterface {
	query: string;
	page: number;
	sorting: string;
	locale: string;
	accessToken?: string;
	bpId?: string;
}

//const SEARCH_API_URL = process.env.NEXT_PUBLIC_ECOMMERCE_API_URL?.endsWith('/') ? process.env.NEXT_PUBLIC_ECOMMERCE_API_URL: `${process.env.NEXT_PUBLIC_ECOMMERCE_API_URL}/`;
// TODO: Delete when environment variables work in dev again
//const SEARCH_API_URL =
//	'https://app-strub2b-cms-dev-001.azurewebsites.net/umbraco/api/search/';
// const contentApiUrl = process.env.NEXT_PUBLIC_CONTENT_API_URL;
const commerceMediaApiUrl = process.env.NEXT_PUBLIC_COMMERCEMEDIA_API_URL;

export interface SearchResultResponse {
	query: string;
	numResults: number;
	totalCount: number;
	products: Models.Product[];
	sortOptions: string[];
}

export const searchAdapter = ({ query, page, sorting, locale, accessToken, bpId }: RequestInterface): Promise<SearchResultResponse> => {
	if (!ECOMMERCE_API_URL) {
		throw new ApiError('SEARCH_API_URL:NOTDEFINED', 500, 'Search api url is not defined');
	}

	const headers = {
		Authorization: `Bearer ${accessToken}`,
	};

	return axios({
		url:
			`${ECOMMERCE_API_URL}search?query=${query ?? ''}&page=${page}&locale=${locale}&bpId=${bpId ?? ''}` +
			(sorting ? `&sortOption=${sorting}` : ''),
		headers: headers,
		method: 'GET',
		maxRedirects: 0,
	})
		.then((res) => {
			const { data } = res ?? {};

			if (data.products) {
				data.products = data.products.map((x) => {
					if (x?.image && !x?.image.includes('http')) {
						//x.image = contentApiUrl + x.image;
						x.image = commerceMediaApiUrl + x.image.replace(/^\/+/, '');
						//x.image = commerceMediaApiUrl + (x.image.charAt(0) == "/")? x.image = x.image.substr(1): x.image;
					}
					return x;
				});
			}

			return data;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			const statusCode = error?.response?.status || 500;

			if (statusCode === 301 || statusCode === 302) {
				throw new ApiRedirect(statusCode, error.response.data.url);
			}

			throw new ApiError('Search API error', statusCode, message);
		});
};

export interface SearchContentResponse {
	results?: {
		id?: string;
		title?: string;
		description?: string;
		url?: string;
		contentType?: string;
		score?: number;
	}[];
	totalResults?: number;
	skip?: number;
	take?: number;
}

export const searchContentAdapter = async (language: string = 'en', query: string): Promise<SearchContentResponse> => {
	if (!CONTENT_API_URL) throw new Error('Missing CONTENT_API_URL');

	const url = `${CONTENT_API_URL}umbraco/api/Search/Search?`;

	const { data } = await axios.get<SearchContentResponse>(url, {
		params: {
			query: query,
			skip: 0,
			take: 100,
			language: language,
		},
	});
	return data;
};
